/**
 * @author Ivan Toth.
 */
var DetailTableBpimsController = (function () {
    function DetailTableBpimsController(topic, $scope, socket, env, notify, Dialog, settings, config) {
        var _this = this;
        this.topic = topic;
        this.$scope = $scope;
        this.socket = socket;
        this.env = env;
        this.notify = notify;
        this.Dialog = Dialog;
        this.settings = settings;
        this.config = config;
        this.show = {
            brand: false,
            main: true,
            summary: true,
            detail: true
        };
        this.showtree = true;
        this.comp = 'calculation';
        this.incentsPaid = {
            SSA: false,
            Solution: false
        };
        this.incentsCount = 0;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.incents = ['SSA', 'Solution'];
        this.getNewUIInfo = {
            uiVersion: _.get(this.topic.checksData, 'uiVersion', 1)
        };
        this.isProcessing = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            if (data.indexOf(_this.comp) > -1) {
                _this.edit = _this.topic.getEditComponent(_this.comp);
            }
            _this.isPaid();
        });
        this.socket.forward("topic.calculation.recalculate", this.$scope);
        this.$scope.$on("socket:topic.calculation.recalculate", function (event, data) {
            _this.topic.temp.calculation = data.calculation;
            _this.isProcessing = false;
            if (data.error) {
                _this.notify.error(data.error);
            }
            else {
                _this.notify.success("Recalculated successfully - Remember to Save your changes");
            }
            return;
        });
        this.socket.forward("topic.calculation.submit", this.$scope);
        this.$scope.$on("socket:topic.calculation.submit", function (event, data) {
            if (_this.topic.topicBrowserID !== data.bID) {
                return _this.notify.error('Browser ID changed. Please, reload.');
            }
            _this.isProcessing = false;
            if (data.error) {
                _this.notify.error(data.error);
                _this.topic.topic.calculation.complete = false;
            }
            else {
                _this.notify.success("Submitted successfully.");
                _this.topic.topic.calculation = data.calculation;
            }
            return;
        });
        this.socket.forward("topic.calculation.revert", this.$scope);
        this.$scope.$on("socket:topic.calculation.revert", function (event, data) {
            _this.isProcessing = false;
        });
    }
    DetailTableBpimsController.prototype.canClickButton = function () {
        this.canClick = false;
        // If user is bpso admin or system admin
        if (this.env.user.access.bpsoAdmin ||
            this.env.user.access.systemAdmin) {
            this.canClick = true; // Enable submit and refresh buttons
        }
    };
    DetailTableBpimsController.prototype.view = function (comp) {
        this.show[comp] = !this.show[comp];
    };
    DetailTableBpimsController.prototype.$onInit = function () {
        this.edit = this.topic.getEditComponent(this.comp);
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_4) {
            this.incents = this.incents.concat(['Focus', 'Growth', 'Ctl']);
            this.incentsPaid.Growth = true;
            this.incentsPaid.Focus = true;
            this.incentsPaid.Ctl = true;
        }
        else {
            this.incents = this.incents.concat(['NewClient']);
            this.incentsPaid.NewClient = true;
        }
        this.canClickButton(); // Set who can click the Submit and Refresh buttons
        this.isPaid();
    };
    DetailTableBpimsController.prototype.changeValue = function () {
        this.topic.temp.calculation.recalculated = false;
    };
    DetailTableBpimsController.prototype.changePayFrq = function () {
        if (this.topic.temp.calculation.payfrq.length > 1) {
            this.topic.temp.calculation.payfrq = this.topic.temp.calculation.payfrq.slice(0, 1);
        }
        this.topic.temp.calculation.recalculated = false;
        this.topic.temp.calculation.manualPayfrq = true;
    };
    DetailTableBpimsController.prototype.getPayementCurrency = function () {
        // should always be there if payment is done
        if (Array.isArray(this.topic.topic.calculation.children) && this.topic.topic.calculation.children.length) {
            return this.topic.topic.calculation.children[0].currency;
        }
        return;
    };
    /**
     * Disables bonus cap rule. Recalculation should be performed after that.
     * @author Pavel Suboch
     * @desc 20180626 - Card 1386 - Pavel Suboch - disable bonus cap rule
     */
    DetailTableBpimsController.prototype.disableBonusCapRule = function (event) {
        var _this = this;
        var items = {
            cancelMessage: 'Cancel',
            dialogName: 'Disable Bonus Cap Rule',
            message: 'Confirm cap disabling, Please.',
            okMessage: 'Save'
        };
        this.Dialog.YesNoForm(undefined, items, 'dialog-disable-cap.html').then(function (dResult) {
            if (dResult.confirm) {
                var bonusCapComments = {
                    time: new Date().getTime(),
                    source: _this.topic.topic.owner,
                    comment: dResult.comment
                };
                _this.addComment(bonusCapComments);
                _this.topic.temp.calculation.disableBonusCap = true;
                _this.topic.temp.calculation.applyBonusCap = false;
                _this.topic.temp.calculation.displayBonusCapButton = false;
            }
        });
    };
    /**
     * Sets comment into temp object to save later
     * @param comment - comment object
     */
    DetailTableBpimsController.prototype.addComment = function (comment) {
        if (!this.topic.temp.comments.payment) {
            this.topic.temp.comments.payment = [];
        }
        this.topic.temp.comments.payment.push(comment);
    };
    DetailTableBpimsController.prototype.showBonusCapButton = function () {
        return (this.topic.topic.calculation &&
            this.topic.topic.calculation.displayBonusCapButton &&
            (!this.topic.temp ||
                !this.topic.temp.calculation ||
                this.topic.temp.calculation.displayBonusCapButton ===
                    'undefined' ||
                this.topic.temp.calculation.displayBonusCapButton));
    };
    DetailTableBpimsController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            // if (!this.calcForm.$valid) {
            //     const items: any = {
            //         icon: 'ERROR',
            //         message: 'You cannot save the Calculations with error(s). &nbsp;Please correct them and click Refresh once done.',
            //         title: 'Saving Error',
            //     };
            //     this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then((dResult) => { return; });
            //     return;
            // }
            if (!this.topic.temp.calculation.recalculated) {
                var items = {
                    icon: 'ERROR',
                    message: 'You need to refresh after doing any changes. &nbsp;Click the Refresh button.',
                    title: 'Saving Error'
                };
                this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
                    return;
                });
                return;
            }
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                var updateObject = {
                    data: {
                        calculation: {
                            add: true,
                            data: this.topic.temp.calculation
                        }
                    },
                    editOption: undefined,
                    id: this.topic.topic._id,
                    type: ['calculation']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.topic.temp.comments.payment = [];
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            if (!this.topic.topic.calculation.payfrq ||
                !(this.topic.topic.calculation.payfrq instanceof Array)) {
                this.topic.topic.calculation.payfrq = [];
            }
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableBpimsController.prototype.isDone = function () {
        return this.config.isOppCalculationCompleted(this.topic.topic.status.status_no, this.topic.topic.status.sub_status_no);
    };
    /**
     * Function to determine if the payment details are in and set....
     */
    DetailTableBpimsController.prototype.isPaid = function () {
        var _this = this;
        var sapResult = angular.isDefined(this.topic.topic.calculation) &&
            angular.isDefined(this.topic.topic.calculation.sapResult)
            ? this.topic.topic.calculation.sapResult
            : undefined;
        this.preApril2018 = false; // Reset
        this.incentsPaid = {
            SSA: false,
            Solution: false,
            NewClient: false,
            Growth: false,
            Focus: false,
            Ctl: false
        }; // Reset
        this.incentsCount = 0; // Reset
        this.incents =
            this.getNewUIInfo.uiVersion >= this.OPP_VERSION_4
                ? this.incents.concat(['Focus', 'Growth', 'Ctl'])
                : (this.incents = this.incents.concat(['NewClient']));
        // If defined and is an array with values or a string with a value
        if (angular.isDefined(sapResult) &&
            ((angular.isArray(sapResult) && sapResult.length > 0) ||
                (angular.isString(sapResult) && sapResult !== ''))) {
            if (this.config.isOppCalculationCompleted(this.topic.topic.status.status_no, this.topic.topic.status.sub_status_no)) {
                if (angular.isArray(sapResult)) {
                    for (var _i = 0, sapResult_1 = sapResult; _i < sapResult_1.length; _i++) {
                        var payment = sapResult_1[_i];
                        for (var _a = 0, _b = this.incents; _a < _b.length; _a++) {
                            var inc = _b[_a];
                            if (payment.hasOwnProperty(inc)) {
                                this.incentsPaid[inc] = true;
                                this.incentsCount++;
                            }
                        }
                    }
                }
                else {
                    // either Set Aside or could be a pre-april credit
                    if (sapResult === 'Set Aside') {
                        if (!angular.isDefined(this.topic.topic.calculation.totalOrderValues)) {
                            this.preApril2018 = true; // No totalOrderValues so old
                            this.incentsPaid.SSA = true;
                            this.incentsCount++;
                        }
                        else {
                            angular.forEach(this.topic.topic.calculation.totalOrderValues, function (v, k) {
                                for (var _i = 0, _a = _this.incents; _i < _a.length; _i++) {
                                    var inc = _a[_i];
                                    // If value is not 0 and matches incentive
                                    if (v !== 0 && k.indexOf(inc) > -1) {
                                        _this.incentsPaid[inc] = true;
                                        _this.incentsCount++;
                                    }
                                }
                            });
                        }
                    }
                    else {
                        // pre april credit
                        this.preApril2018 = true;
                        this.incentsPaid.SSA = true;
                        this.incentsCount++;
                    }
                }
            }
            if (this.topic.topic.calculation.totalSSABonus === 0) {
                this.incentsPaid.SSA = false;
            }
            if (this.topic.topic.calculation.totalSolutionBonus === 0) {
                this.incentsPaid.Solution = false;
            }
            if (this.topic.topic.calculation.totalNewClientBonus === 0) {
                this.incentsPaid.NewClient = false;
            }
            if (this.topic.topic.calculation.totalGrowthBonus === 0) {
                this.incentsPaid.Growth = false;
            }
            if (this.topic.topic.calculation.totalFocusBonus === 0) {
                this.incentsPaid.Focus = false;
            }
            if (this.topic.topic.calculation.totalFocusCtl === 0) {
                this.incentsPaid.Ctl = false;
            }
        }
    };
    DetailTableBpimsController.prototype.getCredit = function (arr, fields) {
        if (angular.isString(arr)) {
            // If a string it can only be Set Aside or a pre-April disbursement with 1 credit for ssa
            if (arr !== 'Set Aside') {
                return fields[0] === 'SSA' ? arr.replace(/'/g, '') : 'N/A';
            }
            return arr ? arr : 'N/A';
        }
        for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
            var entry = arr_1[_i];
            if (entry.hasOwnProperty(fields[0])) {
                return entry[fields[0]] ? entry[fields[0]] : 'N/A';
            }
        }
    };
    DetailTableBpimsController.prototype.getCreditDate = function (arr, fields) {
        if (angular.isString(arr)) {
            return (this.topic.topic.calculation.sapResultTime ||
                this.topic.topic.calculation.created);
        }
        else {
            var cvrDate_1;
            arr.forEach(function (item, index) {
                if (item.hasOwnProperty(fields[0])) {
                    cvrDate_1 = item.sapResultTime;
                }
            });
            return cvrDate_1;
        }
    };
    DetailTableBpimsController.prototype.reCalculate = function () {
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_3) {
            this.topic.temp.calculation.children[0].children[0].drpgId = this.topic.temp.calculation.children[0].children[0].id;
        }
        else {
            this.topic.temp.calculation.children[0].children[0].brandCode = this.topic.temp.calculation.children[0].children[0].id;
        }
        this.isProcessing = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    calculation: this.topic.temp.calculation,
                    docId: this.topic.topic._id
                },
                function: 'reCalculate',
                script: 'detail/payment/v1/payment',
                token: this.env.user.token
            }
        });
        return;
    };
    DetailTableBpimsController.prototype.submit = function () {
        var _this = this;
        if ([4, 6].indexOf(this.topic.topic.status.status_no) < 0) {
            var items_1 = {
                icon: 'ERROR',
                message: 'You can only Submit Calculations in either the Validation or Approved statuses.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items_1, 'confirm-prompt.html').then(function (dResult) {
                return;
            });
            return;
        }
        else {
            if (this.topic.topic.status.status_no === 4 &&
                !this.topic.topic.complete.statusComplete[4]) {
                var items_2 = {
                    icon: 'WARN',
                    message: 'One or more sections for this stage are still to be completed before you can Submit.' +
                        ' &nbsp;Please check for any red thumbs before attempting again.',
                    title: 'Submit'
                };
                this.Dialog.updateValidForm(undefined, items_2, 'confirm-prompt.html').then(function (dResult) {
                    return;
                });
                return;
            }
        }
        if (this.isProcessing) {
            return;
        }
        var msg = 'Payment you are about to submit will result in <strong>';
        if (this.topic.topic.dispute_details &&
            this.topic.topic.dispute_details.dispute_itrtype === 'D') {
            msg +=
                'Debit</strong> note. Are you sure you want to continue?<br><br>Please enter justification';
        }
        else {
            msg +=
                'Credit</strong> note. Are you sure you want to continue?<br><br>Please enter justification';
        }
        var items = {
            icon: 'QUESTION',
            message: msg,
            prompt: true,
            title: 'Submit Calculations'
        };
        this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                // Add justification to calc object
                _this.topic.topic.calculation.justification =
                    dResult.justification;
                _this.isProcessing = true;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: {
                            bID: _this.topic.topicBrowserID,
                            calc: _this.topic.topic.calculation,
                            docId: _this.topic.topic._id
                        },
                        function: 'submit',
                        script: 'detail/payment/v1/payment',
                        token: _this.env.user.token
                    }
                });
                _this.topic.topic.calculation.complete = true;
            }
        });
    };
    DetailTableBpimsController.prototype.removeCalcs = function () {
        var _this = this;
        var items = {
            icon: 'QUESTION',
            message: 'You are about to permanently delete the Calculations. &nbsp;Are you sure?',
            title: 'Remove Calculations'
        };
        this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.isProcessing = true;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: {
                            bID: _this.topic.topicBrowserID,
                            calc: _this.topic.topic.calculation,
                            docId: _this.topic.topic._id
                        },
                        function: 'removeCalcs',
                        script: 'detail/payment/v1/payment',
                        token: _this.env.user.token,
                        user: _this.env.user
                    }
                });
            }
        });
    };
    DetailTableBpimsController.prototype.revertStatus = function () {
        var _this = this;
        // Needs to be in Validation and any of the Set Aside subs
        if (this.topic.topic.status.status_no !== 4 ||
            [13, 15, 16, 17, 18, 19, 20, 21, 22].indexOf(this.topic.topic.status.sub_status_no) < 0) {
            var items_3 = {
                icon: 'ERROR',
                message: 'Only Disbursements in a <b>Set Aside</b> status can be reverted back.',
                title: 'Error'
            };
            this.Dialog.updateValidForm(undefined, items_3, 'confirm-prompt.html').then(function (dResult) {
                return;
            });
            return;
        }
        if (this.isProcessing) {
            return;
        }
        var items = {
            icon: 'QUESTION',
            message: 'Use this function to revert back to a <b>Pending BPSO</b> status and edit the Calculations again.',
            title: 'Revert from Set Aside'
        };
        // If already approved, warn this will wipe the approvals
        if (this.topic.topic.status.approvals.complete) {
            items.message +=
                '<br><br><b style="color:red">NOTE:</b> &nbsp;Should you choose to continue, the' +
                    ' Approvals already granted will be wiped and the Disbursement will need to go through the Approval Process again.';
        }
        items.message += '<br><br>Are you sure?';
        this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.isProcessing = true;
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: {
                            bID: _this.topic.topicBrowserID,
                            calc: _this.topic.topic.calculation,
                            docId: _this.topic.topic._id
                        },
                        function: 'revertStatus',
                        script: 'detail/payment/v1/payment',
                        token: _this.env.user.token,
                        user: _this.env.user
                    }
                });
            }
        });
    };
    DetailTableBpimsController.$inject = [
        'topic',
        '$scope',
        'socket',
        'env',
        'notify',
        'Dialog',
        'settings',
        'config',
    ];
    return DetailTableBpimsController;
}());
var DetailTableBpimsComponent = (function () {
    function DetailTableBpimsComponent() {
        this.templateUrl = 'detail-table-bpims.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableBpimsController;
    }
    return DetailTableBpimsComponent;
}());
angular
    .module('application')
    .component('detailTableBpims', new DetailTableBpimsComponent());

//# sourceMappingURL=detail.table.bpims.component.js.map
